import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "../components/navbar/Navbar";
import Home from "./home/Home";
import About from "./about/About";
import Contact from "./contact/Contact";
import Verification from "./verification/Verification";
import "./App.css";
export default function App() {
    return (_jsx(Router, { children: _jsxs("div", { className: "app-container", children: [_jsx(Navbar, {}), _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(Home, {}) }), _jsx(Route, { path: "/authentication", element: _jsx(Verification, {}) }), _jsx(Route, { path: "/about", element: _jsx(About, {}) }), _jsx(Route, { path: "/contact", element: _jsx(Contact, {}) })] })] }) }));
}
